const data = {
  id: "proposals",
  title: "A Better Huntsville: The Blueprint",
  intro: "The problems are documented. Here are the solutions — evidence-based, tested in other cities, and directly applicable to Huntsville. What a more equitable city actually looks like, and how to get there.",
  tabs: [
    {
      id: "economic_justice",
      label: "Economic Justice",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "housing_infrastructure",
      label: "Housing & Infrastructure",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "public_safety",
      label: "Public Safety Reform",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "governance",
      label: "Governance & Democracy",
      stats: [],
      issues: [],
      trail: []
    }
  ]
};
export default data;
